'use client';

import type { BlogHeroProps } from '@routeroyal/theme-core';
import Image from 'next/image';
import { RouteRoyalBlogSearch } from './RouteRoyalBlogSearch';

export function RouteRoyalBlogHero({
  title,
  subtitle,
  backgroundImage,
  showSearch = false,
  onSearch,
}: BlogHeroProps) {
  return (
    <section className="relative py-24 lg:py-32 overflow-hidden">
      {backgroundImage && (
        <div className="absolute inset-0 z-0">
          <Image src={backgroundImage} alt="" fill className="object-cover" priority />
          <div className="absolute inset-0 bg-gradient-to-b from-blue-950/80 to-blue-900/60" />
        </div>
      )}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h1 className={`text-4xl md:text-5xl lg:text-6xl font-bold mb-4 tracking-tight ${backgroundImage ? 'text-white' : 'text-gray-900'}`}>
          {title}
        </h1>
        {subtitle && (
          <p className={`text-lg md:text-xl mb-8 ${backgroundImage ? 'text-white/85' : 'text-gray-600'}`}>
            {subtitle}
          </p>
        )}
        {showSearch && onSearch && (
          <div className="max-w-xl mx-auto mt-6">
            <RouteRoyalBlogSearch onChange={onSearch} placeholder="Search articles..." />
          </div>
        )}
      </div>
    </section>
  );
}
